// Reference data that never changes within a session: fetched once, shared by every caller.
import * as api from '$api/endpoints.js';

/** @type {Record<string, Promise<any> | undefined>} */
const cache = {};

/**
 * @template T
 * @param {string} key
 * @param {() => Promise<T>} loader
 * @returns {Promise<T>}
 */
function once(key, loader) {
	if (!cache[key]) {
		cache[key] = loader().catch((e) => {
			delete cache[key];
			throw e;
		});
	}
	return /** @type {Promise<T>} */ (cache[key]);
}

export const getBrands = () => once('brands', async () => (await api.listBrands()).brands ?? []);
export const getCategories = () =>
	once('categories', async () => (await api.getCategories()).categories ?? []);
export const getIngredients = () =>
	once('ingredients', async () => (await api.getSearchableIngredients()).ingredients ?? []);
/** @returns {Promise<Record<string, string[]>>} */
export const getRegions = () => once('regions', async () => (await api.getRegions()).regions ?? {});

/** Forget everything (tests). */
export function resetMaster() {
	for (const key of Object.keys(cache)) delete cache[key];
}
